module.exports = __webpack_public_path__ + "static/media/meu_hist.3097ef21.svg";